interface ISystemPromptBehaviors {
    cookieLengthSeconds?: number
}

export class PromptSystemConfigDto {
    public behavior: ISystemPromptBehaviors
}
